export default "__VITE_ASSET__c1800d2b__"